import React from "react";
import { PhoneCall } from 'lucide-react';

const FloatingContact = () => {
  const handleZaloClick = () => {
    window.open('https://zalo.me/84983018234', '_blank');
  };

  const handlePhoneClick = () => {
    window.open('tel:+84983018234', '_self');

  };

  return (
    <div className="fixed bottom-24 right-4 sm:bottom-28 sm:right-6 z-50 flex flex-col gap-3.5">
      {/* Zalo Button */}
      <button
        type="button"
        onClick={handleZaloClick}
        className="group relative grid place-items-center w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-white shadow-lg border border-gray-200 hover:border-gray-300 hover:shadow-xl transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
        title="Chat với chúng tôi qua Zalo"
        aria-label="Chat Zalo"
      >
        <span className="absolute inset-0 rounded-full bg-blue-500/20 animate-ping" aria-hidden="true" />
        <span className="relative grid place-items-center w-11 h-11 sm:w-12 sm:h-12 rounded-full bg-blue-600 text-white group-hover:bg-blue-700 transition-colors">
          <span className="text-[11px] sm:text-xs font-semibold tracking-wide leading-none">
            Zalo
          </span>
        </span>
      </button>

      {/* Phone Button */}
      <button
        type="button"
        onClick={handlePhoneClick}
        className="group relative grid place-items-center w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-white shadow-lg border border-gray-200 hover:border-gray-300 hover:shadow-xl transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 focus-visible:ring-offset-2"
        title="Gọi ngay: 0983018234"
        aria-label="Gọi tư vấn"
      >
        <span className="absolute inset-0 rounded-full bg-amber-500/20 animate-ping [animation-delay:1s]" aria-hidden="true" />
        <span className="relative grid place-items-center w-11 h-11 sm:w-12 sm:h-12 rounded-full bg-amber-500 text-white group-hover:bg-amber-600 transition-colors">
          <PhoneCall size={20} />
        </span>
      </button>
    </div>
  );
};

export default FloatingContact;
